(function () {
  'use strict';

  let angular = window.angular;

  const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  ProfileEditController.$inject = [
    '$scope',
    'Manager',
    'Customer',
    'View',
    'ToolService',
    'AppUtils',
    'LocalStorageService',
  ];

  angular.module('app').component('managerForm', {
    template:'<form name="ctrl.updateForm" class="validate" novalidate autocomplete="off" ng-class="{transparent: ctrl.loading}"><uib-tabset active="ctrl.activeTab"><uib-tab index="0"><uib-tab-heading><span translate>{{::(ctrl.user.id ? \'buttons.edit\' : \'buttons.create\')}}</span> <span translate>entities.user.modelName</span></uib-tab-heading><div class="padding10"><div class="row"><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="ctrl.user.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control input-sm" required><div class="help-block" ng-messages="ctrl.updateForm.nameInput.$error"><div ng-messages-include="messages.html"></div></div></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="surname-input" translate>entities._all.surname</label> <input id="surname-input" name="surnameInput" ng-model="ctrl.user.surname" translate-attr="::{placeholder: \'entities._all.surname\'}" class="form-control input-sm" required><div class="help-block" ng-messages="ctrl.updateForm.surnameInput.$error"><div ng-messages-include="messages.html"></div></div></div></div><div class="col-md-6"><div class="form-group" show-errors><label for="email-input" class="control-label" translate>entities._all.email</label> <input type="email" id="email-input" name="emailInput" ng-model="ctrl.user.email" maxlength="254" pattern="^(?:[A-Za-z][A-Za-z.\\d_\\-]*[A-Za-z\\d]{2,64}|[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,6})$" translate-attr="::{placeholder: \'entities._all.email\'}" class="form-control input-sm" required><div class="help-block" ng-messages="ctrl.updateForm.emailInput.$error" ng-if="ctrl.updateForm.emailInput.$error"><span ng-message="pattern" translate>form.errors.emailFormat</span><div ng-messages-include="messages.html"></div></div></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="username-input" translate>entities._all.username</label> <input id="username-input" name="usernameInput" ng-model="ctrl.user.username" maxlength="64" pattern="^(?:[A-Za-z][A-Za-z.\\d_\\-]*[A-Za-z\\d]{2,64}|[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,6})$" required translate-attr="::{placeholder: \'entities._all.username\'}" class="form-control input-sm"><div class="help-block" ng-messages="ctrl.updateForm.usernameInput.$error" ng-if="ctrl.updateForm.usernameInput.$error"><div ng-messages-include="messages.html"></div></div></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="mobile-input" translate>entities._all.phone</label> <input type="text" id="mobile-input" name="mobileInput" translate-attr="::{placeholder: \'entities._all.phone\'}" ng-model="ctrl.user.phone" pattern="^\\+?[0-9 ()\\-]{6,20}$" maxlength="20" class="form-control input-sm"><div class="help-block" ng-messages="ctrl.updateForm.mobileInput.$error" ng-if="ctrl.updateForm.mobileInput.$error"><span ng-message="pattern" translate>form.errors.phoneFormat</span></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="address-input" translate>entities._all.address</label> <input id="address-input" name="address-input" translate-attr="::{placeholder: \'entities._all.address\'}" ng-model="ctrl.user.address" class="form-control input-sm"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" translate>entities._all.country</label><div class="select2-sm"><ui-select ng-model="ctrl.user.countryId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.country\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="country.id as country in ctrl.countries | filter: {name: $select.search}"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" translate>entities._all.timezone</label><div class="select2-sm"><ui-select ng-model="ctrl.user.timeZoneId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.timezone\' | translate}}">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="timezone.id as timezone in ctrl.timezones | filter: {text: $select.search}"><div ng-bind-html="timezone.text | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div></div><div ng-if="!ctrl.user.id && !ctrl.passwordRequired"><div class="col-md-12"><div class="form-group"><label class="checkbox" style="display: inline-block; width: auto"><input type="checkbox" ng-model="ctrl.setPassword"> <i></i></label> <span translate>entities.user.password.setPassword</span> <span class="fas fa-fw fa-info-circle" style="font-size: 90%; vertical-align: super" uib-tooltip="{{\'entities.user.password.setPasswordInfo\' | translate}}" tooltip-placement="bottom"></span></div></div></div><div ng-if="!ctrl.user.id && ctrl.passwordRequired"><div class="col-md-12"><p class="help-block" translate>entities.user.password.passwordRequired</p></div></div><div ng-if="!ctrl.user.id && ctrl.setPassword"><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="password" translate>entities._all.password</label> <input id="password" type="password" name="password" autocomplete="new-password" translate-attr="::{placeholder: \'entities._all.password\'}" ng-model="ctrl.user.password" ng-change="ctrl.onPasswordChange()" ng-blur="ctrl.onBlurPassword()" ng-required="ctrl.setPassword" ng-minlength="ctrl.minPassLength" class="form-control"><div class="help-block" ng-messages="ctrl.updateForm.password.$error"><span ng-message="weak" translate>entities.user.password.weak</span><div ng-messages-include="messages.html"></div></div></div></div><div class="col-md-6"><div class="form-group" show-errors><label class="control-label" for="confirmPassword" translate>entities.user.password.confirm</label> <input id="confirmPassword" type="password" name="confirmPassword" autocomplete="new-password" translate-attr="::{placeholder: \'entities.user.password.confirm\'}" ng-model="ctrl.user.confirmPassword" ng-change="ctrl.onPasswordChange()" ng-blur="ctrl.onBlurPassword()" ng-required="ctrl.setPassword" ng-minlength="ctrl.minPassLength" class="form-control"><div class="help-block" ng-messages="ctrl.updateForm.confirmPassword.$error"><div ng-messages-include="messages.html"></div></div></div></div><div class="col-md-12"><ul class="list-unstyled marginB10" style="font-size: 12px"><li ng-class="ctrl.requirements.length ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.length ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLength</span></li><li ng-class="ctrl.requirements.upper ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.upper ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqUpper</span></li><li ng-class="ctrl.requirements.lower ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.lower ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLower</span></li><li ng-class="ctrl.requirements.digit ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.digit ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqDigit</span></li><li ng-class="ctrl.requirements.symbol ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.symbol ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqSymbol</span></li></ul></div></div></div></div></uib-tab><uib-tab index="1"><uib-tab-heading><span translate>entities.permission.modelNamePl</span></uib-tab-heading><div class="paddingLR10"><label class="checkbox"><input type="checkbox" ng-model="ctrl.isMaster" ng-change="ctrl.toggleMaster()"> <i></i> <span translate>entities.user.isMaster</span></label></div><hr class="marginTB10"><div style="height: 400px; overflow-y: auto" class="paddingLR5"><permissions-category ng-repeat="(category, permissions) in ctrl.permissions" on-change="ctrl.checkMaster()" category="category" permissions="permissions"></permissions-category></div></uib-tab></uib-tabset><div class="alert alert-warning marginTB0 marginLR10 text-center paddingLR10" style="white-space: pre-line; margin-bottom: 15px !important" ng-show="ctrl.saveError">{{ctrl.saveError.message || ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="ctrl.saveProfile()" translate>buttons.save</button></div></form><spinner css-class="\'small\'" show-logo="true" show="ctrl.loading"></spinner>',
    controller: ProfileEditController,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function ProfileEditController(
    $scope,
    Manager,
    Customer,
    View,
    ToolService,
    utils,
    LocalStorageService
  ) {
    let vm = this;
    vm.isMaster = false;

    vm.$onInit = function onInit() {
      vm.customerId = vm.resolve.customerId;
      vm.user = angular.copy(vm.resolve.user);
      vm.countries = vm.resolve.countries;
      vm.timezones = vm.resolve.timezones;
      vm.activeTab = 0;
      vm.passwordRequired = false;
      vm.setPassword = false;
      vm.minPassLength = 8;
      vm.requirements = { length: false, upper: false, lower: false, digit: false, symbol: false };

      vm.checkMaster = checkMaster;

      vm.loading = true;
      let manager;
      let tools;
      const toolModules = ToolService.getToolsModules();

      loadEmailVerificationRequired()
        .then(() => loadManager())
        .then((result) => {
          manager = result;
          vm.userPermissions = manager.permission || {};
          vm.userViews = manager.views || [];
          return Customer.prototype$__get__tools({ id: vm.customerId }).$promise;
        })
        .then((result) => {
          tools = result;
          return View.find({ fields: ['id', 'module'] }).$promise;
        })
        .then((views) => {
          vm.views = views;
          vm.permissions = {
            connection: [
              {
                id: 'apiKeys',
                module: 'xompassApiKeys',
                value: {
                  create: false,
                  update: false,
                  delete: false,
                  view: hasModule('xompassApiKeys'),
                },
              },
              {
                id: 'telegramChats',
                module: 'xompassTelegramChats',
                value: {
                  create: false,
                  update: false,
                  delete: false,
                  view: hasModule('xompassTelegramChats'),
                },
              },
              {
                id: 'devices',
                module: 'xompassEdgeDevices',
                value: {
                  create: false,
                  update: false,
                  delete: false,
                  view: hasModule('xompassEdgeDevices'),
                },
                children: [
                  { id: 'edgeAgents', value: { create: false, update: false, delete: false } },
                ],
              },
            ],
            contextualization: [
              {
                id: 'virtualExpressions',
                module: 'xompassKPIEngine',
                value: {
                  create: false,
                  update: false,
                  delete: false,
                  view: hasModule('xompassKPIEngine'),
                },
              },
              {
                id: 'assets',
                module: 'xompassContextualization',
                value: {
                  create: false,
                  update: false,
                  delete: false,
                  view: hasModule('xompassContextualization'),
                },
                children: [
                  { id: 'assetStates', value: { create: false, update: false, delete: false } },
                  { id: 'eventGroups', value: { create: false, update: false, delete: false } },
                  { id: 'eventTriggers', value: { create: false, update: false, delete: false } },
                  { id: 'sensors', value: { create: false, update: false, delete: false } },
                ],
              },
              {
                id: 'responseProtocols',
                module: 'xompassResponseProtocol',
                value: {
                  create: false,
                  update: false,
                  delete: false,
                  view: hasModule('xompassResponseProtocol'),
                },
              },
            ],
            events: [
              {
                id: 'eventDashboards',
                value: { create: false, update: false, delete: false },
                children: [
                  { id: 'events', value: { update: false } },
                  { id: 'eventComments', value: { create: false, update: false, delete: false } },
                  {
                    id: 'defaultEventComments',
                    value: { create: false, update: false, delete: false },
                  },
                  { id: 'eventStates', value: { create: false, update: false, delete: false } },
                ],
              },
              {
                id: 'deviceEventDashboard',
                children: [{ id: 'deviceEvents', value: { update: false } }],
              },
              {
                id: 'healthcheckEventDashboard',
                children: [{ id: 'healthcheckEvents', value: { update: false } }],
              },
            ],
            listedLicensePlates: [
              {
                id: 'listedLicensePlates',
                value: { create: false, update: false, delete: false },
              },
            ],
            /* faceDatabases: [
              {
                id: 'faceDatabases',
                value: { create: false, update: false, delete: false },
              },
            ], */
            apps: [
              // { id: 'projects', value: { create: false, update: false, delete: false } },
              { id: 'biPanels', value: { create: false, update: false, delete: false } },
              { id: 'reports', value: { create: false, update: false, delete: false } },
              { id: 'gis', value: { create: false, update: false, delete: false } },
              {
                id: 'peopleCounterReports',
                value: { create: false, update: false, delete: false },
              },
              {
                id: 'countReports',
                value: { create: false, update: false, delete: false },
              },
              { id: 'embeddedReports', value: { create: false, update: false, delete: false } },
              { id: 'processLayouts', value: { create: false, update: false, delete: false } },
              // { id: 'storeDashboards', value: { create: false, update: false, delete: false } },
              { id: 'trafficFlowAnalysis', value: { create: false, update: false, delete: false } },
              {
                id: 'storylines',
                value: { create: false, update: false, delete: false },
                children: [
                  {
                    id: 'storylineCategories',
                    value: { create: false, update: false, delete: false },
                  },
                ],
              },
            ],
          };

          const events = tools.find(
            (current) =>
              current.module === 'xompassEventDashboard' || current.module === 'xompassEventHistory'
          );

          if (!events) {
            delete vm.permissions.events;
          }

          vm.permissions.apps = vm.permissions.apps.filter((toolPerm) => {
            const modules = Object.values(toolModules);
            const module = modules.find((current) => current.permission === toolPerm.id);
            if (!module) {
              return true;
            }
            return !!tools.find((current) => current.module === module.module);
          });

          if (vm.userPermissions && typeof vm.userPermissions.master === 'boolean') {
            vm.isMaster = vm.userPermissions.master;
          }

          vm.plainPermissions = getPlainPermissions();
          toggleMaster();
          vm.datepickerOps = {
            showWeeks: false,
          };

          vm.saveProfile = saveProfile;
          vm.onBlurPassword = onBlur;
          vm.onPasswordChange = onPasswordChange;
          vm.toggleMaster = toggleMaster;
          vm.loading = false;
        })
        .catch((err) => {
          console.log(err);
          vm.loading = false;
        });
    };

    function loadEmailVerificationRequired() {
      if (vm.user && vm.user.id) {
        return utils.Promise.resolve();
      }

      return utils.getEmailVerificationRequired('Managers').then((required) => {
        vm.passwordRequired = required === false;
        vm.setPassword = vm.passwordRequired;
      });
    }

    function loadManager() {
      if (vm.user && vm.user.id) {
        vm.loading = true;
        return Customer.prototype$__get__managers({
          id: vm.customerId,
          filter: {
            where: { id: vm.user.id },
            include: ['permission', { relation: 'views', scope: { fields: ['id', 'module'] } }],
          },
        })
          .$promise.then((result) => {
            vm.loading = false;
            return result[0];
          })
          .catch((err) => {
            vm.loading = false;
          });
      } else {
        return utils.Promise.resolve({});
      }
    }

    function checkMaster() {
      let count = 0;
      vm.plainPermissions.forEach((permission) => {
        if (!permission.value || !Object.keys(permission.value).length) {
          count++;
          return;
        }

        let isTrue = true;
        for (let prop in permission.value) {
          isTrue = isTrue && permission.value[prop];
        }
        if (isTrue) {
          count++;
        }
      });

      if (count !== vm.plainPermissions.length) {
        vm.isMaster = false;
      }
    }

    function getPlainPermissions() {
      const permissions = [];
      for (let permissionGroup in vm.permissions) {
        const current = vm.permissions[permissionGroup];
        for (let permission of current) {
          if (permission.value && Object.keys(permission.value).length) {
            permissions.push(permission);
          }
          if (permission.children) {
            Array.prototype.push.apply(
              permissions,
              permission.children.filter((perm) => perm.value && Object.keys(perm.value).length)
            );
          }
        }
      }
      return permissions;
    }

    function toggleMaster() {
      vm.plainPermissions.forEach((current) => {
        let id = current.id;
        let value = current.value;

        let perm = vm.userPermissions ? vm.userPermissions[id] : null;
        if (perm) {
          for (let operation in perm) {
            if (value[operation] !== undefined) {
              value[operation] = vm.isMaster
                ? true
                : typeof perm[operation] === 'boolean'
                ? perm[operation]
                : false;
            }
          }
          if (current.module) {
            value.view = vm.isMaster ? true : typeof value.view === 'boolean' ? value.view : false;
          }
        } else {
          for (let operation in value) {
            value[operation] = vm.isMaster;
          }
        }
      });
    }

    function hasModule(module) {
      return vm.userViews.findIndex((current) => current.module === module) !== -1;
    }

    function onBlur() {
      if (!vm.setPassword) {
        return;
      }

      let password = vm.user.password;
      let repeatPassword = vm.user.confirmPassword;

      if (password && repeatPassword && password !== repeatPassword) {
        vm.updateForm.password.$setValidity('passwordMismatch', false);
        vm.updateForm.confirmPassword.$setValidity('passwordMismatch', false);
      } else {
        vm.updateForm.password.$setValidity('passwordMismatch', true);
        vm.updateForm.confirmPassword.$setValidity('passwordMismatch', true);
      }
    }

    function onPasswordChange() {
      if (!vm.setPassword) {
        return;
      }

      let password = vm.user.password || '';
      let repeatPassword = vm.user.confirmPassword || '';

      vm.requirements.length = password.length >= vm.minPassLength;
      vm.requirements.upper = /[A-Z]/.test(password);
      vm.requirements.lower = /[a-z]/.test(password);
      vm.requirements.digit = /\d/.test(password);
      vm.requirements.symbol = /[^A-Za-z0-9]/.test(password);

      if (!password || !repeatPassword || password === repeatPassword) {
        vm.updateForm.password.$setValidity('passwordMismatch', true);
        vm.updateForm.confirmPassword.$setValidity('passwordMismatch', true);
      }
    }

    function saveProfile() {
      if (!vm.user.id && vm.setPassword) {
        if (vm.user.password !== vm.user.confirmPassword) {
          vm.updateForm.password.$setValidity('passwordMismatch', false);
          vm.updateForm.confirmPassword.$setValidity('passwordMismatch', false);
        }

        vm.updateForm.password.$setValidity(
          'weak',
          STRONG_PASSWORD_REGEX.test(vm.user.password || '')
        );
      }

      if (!vm.updateForm.$valid) {
        vm.activeTab = 0;
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      let promise;
      if (vm.user.id) {
        promise = Manager.prototype$patchAttributes(
          {
            id: vm.user.id,
          },
          {
            name: vm.user.name,
            surname: vm.user.surname,
            //email: vm.user.email,
            phone: vm.user.phone,
            birthday: vm.user.birthday,
            address: vm.user.address,
            countryId: vm.user.countryId,
            timeZoneId: vm.user.timeZoneId,
          }
        ).$promise;
      } else {
        const newManager = {
          name: vm.user.name,
          surname: vm.user.surname,
          email: vm.user.email,
          phone: vm.user.phone,
          birthday: vm.user.birthday,
          address: vm.user.address,
          countryId: vm.user.countryId,
          timeZoneId: vm.user.timeZoneId,
          username: vm.user.username,
        };

        if (vm.setPassword) {
          newManager.password = vm.user.password;
        }

        promise = Customer.prototype$__create__managers(
          {
            id: vm.customerId,
          },
          newManager
        ).$promise;
      }

      vm.loading = true;

      const views = {};
      let user;

      promise
        .then((result) => {
          user = result;
          vm.user = user;

          let perms = { master: vm.isMaster };
          vm.plainPermissions.forEach((current) => {
            current = angular.copy(current);
            delete current.value.id;
            if (current.value.view !== undefined) {
              views[current.module] = current.value.view;
              delete current.value.view;
            }

            current.value.read =
              typeof current.value.read === 'boolean' ? current.value.read : true;

            perms[current.id] = current.value;
          });

          return Manager.prototype$__update__permission({ id: user.id }, perms).$promise;
        })
        .then(() => {
          return updateViews(views);
        })
        .then(() => {
          vm.loading = false;
          LocalStorageService.clear();
          vm.modalInstance.close(user);
        })
        .catch((err) => {
          vm.loading = false;
          vm.saveError = utils.getHTTPError(err);
        });
    }

    function updateViews(views) {
      const added = [];
      const removed = [];

      for (let module in views) {
        const view = vm.userViews.find((current) => current.module === module);
        if (!view && views[module] === true) {
          added.push(module);
        } else if (view && views[module] === false) {
          removed.push(module);
        }
      }

      let link = [];
      let unlink = [];
      for (let module of added) {
        const view = vm.views.find((current) => current.module === module);
        if (!view) {
          continue;
        }

        link.push({
          function: Manager.prototype$__link__views,
          args: [{ id: vm.user.id, fk: view.id }, {}],
        });
      }

      for (let module of removed) {
        const view = vm.views.find((current) => current.module === module);
        if (!view) {
          console.log(module);
          continue;
        }

        unlink.push({
          function: Manager.prototype$__unlink__views,
          args: [{ id: vm.user.id, fk: view.id }, {}],
        });
      }
      return utils.parallelPromises(link).then((result) => {
        return utils.parallelPromises(unlink);
      });
    }
  }
})();
